import { useEffect, useState } from "react"

const NotFound = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 })
  const [isHovering, setIsHovering] = useState(false)

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY })
    }

    window.addEventListener("mousemove", handleMouseMove)

    return () => {
      window.removeEventListener("mousemove", handleMouseMove)
    }
  }, [])

  const calculateParallax = (strength = 20) => {
    const centerX = window.innerWidth / 2
    const centerY = window.innerHeight / 2

    const deltaX = (mousePosition.x - centerX) / strength
    const deltaY = (mousePosition.y - centerY) / strength

    return { x: deltaX, y: deltaY }
  }

  const parallax = calculateParallax()

  const stars = []
  for (let i = 0; i < 20; i++) {
    const size = Math.random() * 3 + 1
    const top = Math.random() * 100
    const left = Math.random() * 100
    const opacity = Math.random() * 0.5 + 0.3
    const duration = Math.random() * 5 + 3
    const delay = Math.random() * 5

    stars.push(
      <div
        key={i}
        style={{
          position: "absolute",
          top: `${top}%`,
          left: `${left}%`,
          width: `${size}px`,
          height: `${size}px`,
          borderRadius: "50%",
          backgroundColor: "white",
          opacity: opacity,
          animation: `twinkle ${duration}s infinite ${delay}s`,
        }}
      />,
    )
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "linear-gradient(to bottom right, #E5EDF1, #d9e6f0)",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <style
        dangerouslySetInnerHTML={{
          __html: `
        @keyframes float {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-20px);
          }
        }
        
        @keyframes pulse {
          0%, 100% {
            opacity: 0.2;
            transform: scale(1);
          }
          50% {
            opacity: 0.3;
            transform: scale(1.1);
          }
        }
        
        @keyframes twinkle {
          0%, 100% {
            opacity: 0.2;
            transform: scale(1);
          }
          50% {
            opacity: 0.7;
            transform: scale(1.3);
          }
        }
        
        @keyframes ripple {
          0% {
            transform: scale(0);
            opacity: 0.5;
          }
          100% {
            transform: scale(1);
            opacity: 0;
          }
        }

        @keyframes bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-3px);
          }
        }
      `,
        }}
      />

      <div
        style={{
          position: "absolute",
          inset: 0,
          overflow: "hidden",
          perspective: "500px",
          transformStyle: "preserve-3d",
        }}
      >
        {stars}
      </div>

      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "16rem",
          height: "16rem",
          borderRadius: "50%",
          background: "linear-gradient(to bottom right, #4A628A, #5d7aa8)",
          opacity: 0.05,
          filter: "blur(16px)",
          transform: `translate(${parallax.x * -1.5}px, ${parallax.y * -1.5}px)`,
          transition: "transform 0.1s ease-out",
        }}
      ></div>

      <div
        style={{
          position: "absolute",
          bottom: 0,
          right: 0,
          width: "24rem",
          height: "24rem",
          borderRadius: "50%",
          background: "linear-gradient(to top left, #4A628A, #5d7aa8)",
          opacity: 0.05,
          filter: "blur(16px)",
          transform: `translate(${parallax.x * 1.5}px, ${parallax.y * 1.5}px)`,
          transition: "transform 0.1s ease-out",
        }}
      ></div>

      <div
        style={{
          position: "absolute",
          top: "25%",
          right: "25%",
          width: "8rem",
          height: "8rem",
          borderRadius: "50%",
          background: "linear-gradient(to bottom right, #bad5ee, #8fb8e0)",
          opacity: 0.2,
          filter: "blur(8px)",
          transform: `translate(${parallax.x * 2}px, ${parallax.y * 2}px)`,
          transition: "transform 0.1s ease-out",
        }}
      ></div>

      <div
        style={{
          position: "absolute",
          bottom: "25%",
          left: "25%",
          width: "12rem",
          height: "12rem",
          borderRadius: "50%",
          background: "linear-gradient(to top right, #bad5ee, #8fb8e0)",
          opacity: 0.1,
          filter: "blur(16px)",
          transform: `translate(${parallax.x * -2.5}px, ${parallax.y * -2.5}px)`,
          transition: "transform 0.1s ease-out",
        }}
      ></div>

      <div
        style={{
          width: "100%",
          maxWidth: "42rem",
          padding: "2rem",
          textAlign: "center",
          position: "relative",
          zIndex: 10,
        }}
      >
        <div
          style={{
            marginBottom: "3rem",
            transform: isHovering ? "scale(1.1)" : "scale(1)",
            transition: "transform 0.5s",
            cursor: "pointer",
          }}
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
        >
          <div style={{ position: "relative" }}>
            <div
              style={{
                color: "#4A628A",
                fontSize: "9rem",
                fontWeight: 800,
                opacity: 0.1,
                userSelect: "none",
                textShadow: "0 10px 20px rgba(74, 98, 138, 0.2)",
                animation: "float 6s ease-in-out infinite",
              }}
            >
              404
            </div>
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div style={{ position: "relative" }}>
                <svg
                  style={{
                    width: "10rem",
                    height: "10rem",
                    color: "#426686",
                    filter: "drop-shadow(0 4px 6px rgba(66, 102, 134, 0.3))",
                    animation: "float 6s ease-in-out infinite",
                    transform: isHovering ? "scale(1.1)" : "scale(1)",
                    transition: "transform 0.5s",
                  }}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    style={isHovering ? { animation: "pulse 2s infinite" } : {}}
                  />
                  <path
                    d="M9 10C9.55228 10 10 9.55228 10 9C10 8.44772 9.55228 8 9 8C8.44772 8 8 8.44772 8 9C8 9.55228 8.44772 10 9 10Z"
                    fill="currentColor"
                    style={isHovering ? { animation: "bounce 1s infinite" } : {}}
                  />
                  <path
                    d="M15 10C15.5523 10 16 9.55228 16 9C16 8.44772 15.5523 8 15 8C14.4477 8 14 8.44772 14 9C14 9.55228 14.4477 10 15 10Z"
                    fill="currentColor"
                    style={isHovering ? { animation: "bounce 1s infinite" } : {}}
                  />
                  <path
                    d={isHovering ? "M9 16C10.5 18 13.5 18 15 16" : "M9 17C10.5 15 13.5 15 15 17"}
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    style={{ transition: "all 0.3s" }}
                  />
                </svg>
                <div
                  style={{
                    position: "absolute",
                    bottom: "-0.5rem",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "4rem",
                    height: "1rem",
                    backgroundColor: "#426686",
                    opacity: 0.2,
                    borderRadius: "9999px",
                    filter: "blur(8px)",
                    animation: "pulse 2s infinite",
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            backdropFilter: "blur(10px)",
            padding: "2rem",
            borderRadius: "1rem",
            boxShadow: "0 10px 40px rgba(66, 102, 134, 0.15), inset 0 -3px 0 rgba(66, 102, 134, 0.1)",
            border: "1px solid #bad5ee",
            transform: `perspective(1000px) rotateX(${parallax.y * 0.05}deg) rotateY(${parallax.x * -0.05}deg)`,
            transition: "all 0.5s",
          }}
        >
          <h1
            style={{
              color: "transparent",
              backgroundImage: "linear-gradient(to right, #41567c, #5d7aa8)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              fontSize: "2.5rem",
              fontWeight: "bold",
              marginBottom: "1rem",
              textShadow: "0 2px 10px rgba(65, 86, 124, 0.1)",
            }}
          >
            Oops! Page Not Found
          </h1>

          <div
            style={{
              width: "8rem",
              height: "0.25rem",
              margin: "1.5rem auto",
              borderRadius: "9999px",
              background: "linear-gradient(to right, #bad5ee, #8fb8e0)",
            }}
          ></div>

          <p
            style={{
              color: "#426686",
              fontSize: "1.125rem",
              marginBottom: "2rem",
              lineHeight: "1.7",
            }}
          >
            The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
          </p>

          <button
            style={{
              position: "relative",
              padding: "0.75rem 2rem",
              background: "linear-gradient(to right, #4A628A, #5d7aa8)",
              color: "white",
              fontSize: "1.125rem",
              borderRadius: "9999px",
              border: "none",
              boxShadow: "0 10px 15px -3px rgba(66, 102, 134, 0.2)",
              cursor: "pointer",
              overflow: "hidden",
              transition: "transform 0.3s, box-shadow 0.3s",
              transform: "scale(1)",
              outline: "none",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.05)"
              e.currentTarget.style.boxShadow = "0 20px 25px -5px rgba(66, 102, 134, 0.3)"
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)"
              e.currentTarget.style.boxShadow = "0 10px 15px -3px rgba(66, 102, 134, 0.2)"
            }}
            onClick={() => (window.location.href = "/")}
          >
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: "linear-gradient(to right, #5d7aa8, #4A628A)",
                opacity: 0,
                transition: "opacity 0.3s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.opacity = "1"
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.opacity = "0"
              }}
            ></div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                zIndex: 10,
              }}
            >
              <svg
                style={{
                  width: "1.25rem",
                  height: "1.25rem",
                  marginRight: "0.5rem",
                  transition: "transform 0.3s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateX(-4px)"
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateX(0)"
                }}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M10 19l-7-7m0 0l7-7m-7 7h18"
                ></path>
              </svg>
              <span style={{ position: "relative" }}>Return to Home</span>
            </div>

            <div
              style={{
                position: "absolute",
                inset: 0,
                borderRadius: "9999px",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  backgroundColor: "white",
                  opacity: 0,
                  transition: "opacity 0.3s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.opacity = "0.1"
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.opacity = "0"
                }}
              ></div>

              <div
                style={{
                  position: "absolute",
                  top: "-100%",
                  left: "-100%",
                  right: "-100%",
                  bottom: "-100%",
                  backgroundColor: "white",
                  opacity: 0,
                  transition: "opacity 0.3s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.opacity = "0.05"
                  e.currentTarget.style.animation = "ripple 1s"
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.opacity = "0"
                  e.currentTarget.style.animation = "none"
                }}
              ></div>
            </div>
          </button>
        </div>

        <div
          style={{
            marginTop: "2rem",
            color: "#426686",
            fontSize: "0.875rem",
          }}
        >
          <a
            href="/contact"
            style={{
              position: "relative",
              color: "#4A628A",
              textDecoration: "none",
              zIndex: 10,
            }}
            // onMouseEnter={(e) => {
            //   e.currentTarget.style.color = "#41567c"
            //   e.currentTarget.nextElementSibling.style.width = "100%"
            // }}
            // onMouseLeave={(e) => {
            //   e.currentTarget.style.color = "#4A628A"
            //   e.currentTarget.nextElementSibling.style.width = "0"
            // }}
          >
            Contact support
            <span
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: 0,
                height: "2px",
                background: "linear-gradient(to right, #4A628A, #5d7aa8)",
                transition: "width 0.3s",
              }}
            ></span>
          </a>{" "}
          if you believe this is an error.
        </div>
      </div>
    </div>
  )
}

export default NotFound

